module.exports = __webpack_public_path__ + "img/about_us_hero_mobile.17fa6c57.webp";